module.exports = __webpack_public_path__ + "asset/image-Cross-6b8124402f5bae9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Cross.svg
// module id = bLl/
// module chunks = 0